goog.provide('el8.appchart.mainFeeds.chartAddlRenderItemFn');

goog.require('el8.appchart.mainFeeds.billElationStaffRenderer');
goog.require('el8.appchart.permissions');
goog.require('el8.appservice.highlighter');
goog.require('el8.appshared.docTags.tooltips');
goog.require('el8.appshared.letterFeedRenderer');
goog.require('el8.ptdata.fetch');
goog.require('el8.template.render.chartFeedItem.visitNoteContent');
goog.require('el8.template.appshared.docTags');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.util.consts');
goog.require('el8.util.feed');
goog.require('el8.appshared.react.renderNewMessageThread');


el8.appchart.mainFeeds.chartAddlRenderItemFn = function(renderedItem, item) {
    if (!item) return;

    function nonvisitRenderedItemFn($elt, item) {
        var fid = $elt.attr('_fid');
        var item = item || el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
        var hasImages = Boolean(item.getImages().length);

        // Load images, if any
        if (hasImages) {
            el8.util.feed.loadImages({
                item: item,
                images: item.getImages(),
                container: $elt,
                width: '100%',
                zoomable: true
            });
        }

        el8.appshared.docTags.tooltips.create($elt, item);
    }

    function visitRenderedItemFn($elt, item) {
        var fid = $elt.attr('_fid');
        var item = item || el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));

        // Set up collapsible
        if ($('.collapsible-section', $elt).length) {
            _make_visit_collapsible(item, $('.collapsible-section', $elt), $elt);
        } else {
            // If there are no collapsible sections in the note content, remove the status element
            // and don't show a clickable top line
            $('.visit-note-toggle-collapse-status', $elt).remove();

            // For new chart VNs with <a> top lines deanchorify them
            $('.visit-note-toggle-collapse-trigger', $elt).replaceWith(
                $('.visit-note-toggle-collapse-trigger', $elt).text()
            );
        }

        // Tease
        if (el8Globals.TEASE) {
            $('button', $elt).prop('disabled', true);
            $('.addToNoteHpiTrigger', $elt).remove();
            $('.itemActionWrap', $elt).addClass('itemNoActionWrap').removeClass('itemActionWrap');
        }

        // ELATIONSTAFF
        if (el8Globals.ELATIONSTAFF) {
            el8.appchart.mainFeeds.billElationStaffRenderer.render($elt, item);
        }

        // Tooltips for docTags
        el8.appshared.docTags.tooltips.create($elt, item);

        // Preview notes have an extra header "edit" convenience link
        $elt.on('click', '.visit-note-preview-edit-trigger',  function() {
            el8.appchart.visitNote.main.editPreviewedNote(item.getId());
            return false;
        });
    }

    function _make_visit_collapsible(item, container, $elt) {
        var $triggerElt = $('.visit-note-toggle-collapse-trigger', $elt);
        var $statusElt = $('.visit-note-toggle-collapse-status', $elt);

        el8.uiwidget.collapsible({
            container: container,
            triggerElt: $triggerElt,
            statusElt: $statusElt,
            collapseFn: function() { _collapseFn(item, $elt); },
            expandFn: function() { _expandFn(item, $elt); },
            // The latest visit note, previewed notes, and notes in searches are default-expanded
            isCollapsed: el8Globals.TEASE ? false : (
                (item.isSignedOff() && !item.getCurrentEditId() &&
                (item.getId() !== el8.ptdata.visitNotes.getLatestId())) &&
                !el8.appservice.highlighter.getSearchTerms()
            )
        });
    }

    /**
     * Handler for visit note feed item collapse
     */
    function _collapseFn(item, $elt) {
        // Append summary description
        var obj = el8.ptdata.model.note.asSoyMap(item);
        var descriptionHtml = el8.template.render.chartFeedItemNew.visitNoteDescription(obj);
        $('.el8FeedItemColMainTopLine .visit-note-description', $elt).html(descriptionHtml);

        // Update feed item content toggle button text
        $('.visit-note-toggle-collapse-status', $elt).text('Expand');

        var images = item.getThumbnails(); // thumbnails
        if (images.length) {
            var imageTemplateFn = el8.template.render.chartFeedItem.visitNoteContent.elidedImageList;
            $('.visit-image-section', $elt).html(imageTemplateFn({id: item.getId(), images: images}));
            el8.util.feed.loadImages({
                item: item,
                images: images.slice(0, el8.util.consts.MAX_VISIT_SUMMARY_IMAGES),
                container: $elt,
                width: undefined,
                zoomable: true
            });
        }
    }

    /**
     * Handler for visit note feed item expand
     */
    function _expandFn(item, $elt) {
        // Refresh topline
        var obj = el8.ptdata.model.note.asSoyMap(item);
        var descriptionHtml = el8.template.render.chartFeedItemNew.visitNoteDescription(obj);
        $('.el8FeedItemColMainTopLine .visit-note-description', $elt).html(descriptionHtml);

        // Update feed item content toggle button text
        $('.visit-note-toggle-collapse-status', $elt).text('Collapse');

        var images = item.getImages(); // full images
        if (images.length) {
            var imageTemplateFn = el8.template.render.chartFeedItem.visitNoteContent.imageList;
            $('.visit-image-section', $elt).html(imageTemplateFn({id: item.getId(), images: images}));
            el8.util.feed.loadImages({
                item: item,
                images: images,
                container: $elt,
                width: '100%',
                zoomable: true
            });
        }
    }

    function _change_visit_state(item, $elt, summaryMode) {
        var itemDescriptionText = el8.appservice.highlighter.highlightText(item.getDescription());
        var toggleSummaryText = 'View Summary';
        var images = item.getImages();
        var width = '100%';
        if (summaryMode) {
            itemDescriptionText = el8.appservice.highlighter.highlightText(item.getDescription()) + ' Summary';
            toggleSummaryText = 'View Complete Note';
            images = item.getThumbnails();
            width = undefined;
        }

        $('.item-description-text', $elt).html(itemDescriptionText); // after calling highlightText, this has HTML in it
        $('.toggle-summary-trigger', $elt).text(toggleSummaryText);
        if (images.length) {
            var imageTemplateFn = (summaryMode) ?
                el8.template.render.chartFeedItem.visitNoteContent.elidedImageList :
                el8.template.render.chartFeedItem.visitNoteContent.imageList;
            $('.visit-image-section', $elt).html(
                imageTemplateFn({
                    id: item.getId(),
                    images: images
                })
            );
            el8.util.feed.loadImages({
                item: item,
                images: (summaryMode) ? images.slice(0, el8.util.consts.MAX_VISIT_SUMMARY_IMAGES) : images,
                container: $elt,
                width: width,
                zoomable: true
            });
        }
    }

    /**
     * Visit notes, non-visit notes, and letters need some extra bells and
     * whistles around loading images and adding collapsibility
     */
    var isPlrItem = renderedItem.hasClass('plr-result');
    var isVisitNote = renderedItem.hasClass('visit-note-item');
    var isNonvisitNote = renderedItem.hasClass('nonvisit-note-item');
    var isLetter = renderedItem.hasClass('letter-item');
    var isLetterReceipt = renderedItem.hasClass('letter-receipt-item');
    var isReport = renderedItem.hasClass('report-item');

    // TODO: see what functionality we actually need to preserve here (doc tags?)
    // item.isChartItemExpanded looks old
    if (isPlrItem) { return; }

    if (isNonvisitNote) {
        nonvisitRenderedItemFn(renderedItem, item);
    } else if (isVisitNote) {
        visitRenderedItemFn(renderedItem, item);
    } else if (isLetter || isLetterReceipt) {
        var fid = renderedItem.attr('_fid');
        item = item || el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
        el8.appshared.letterFeedRenderer.render(renderedItem, item, false);

        // this block is chart-feed specific, so it doesn't live in letterFeedRenderer
        if (item.isChartItemExpanded()) {
            $('.letter-toggle-collapse-trigger', renderedItem).trigger('el8_expand');
        }
    } else if (isReport) {
        el8.appshared.docTags.tooltips.create($(renderedItem), item);
    } else if ($(renderedItem).find('.doc-tag-icon').length) {
        el8.appshared.docTags.tooltips.create($(renderedItem), item);
    } else if (item.is('MedOrder')) {
      // Init surescripts explanation tooltip
      el8.service.tooltip.create({
        anchor: $('.explain-surescripts-trigger', renderedItem),
        text: 'The pharmacy has permanently accepted the order.'
      });
    }
    else if (item.is('MessageThread') && el8Globals.FEATURES.NewOfficeMessages) {
        el8.appshared.react.renderNewMessageThread(renderedItem, {
            feedName: 'chart',
            messages: [item.asSoyMap(true)],
            itemId: item.getId(),
            onReplySuccess: function refresh() {}
        });
    }
};
